import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Role } from "@/lib/auth/rbac";

export interface AuthUser {
  userId: string;
  username: string;
  fullName: string;
  role: Role;
  /** Restaurant the account belongs to — null for platform (SUPER_ADMIN) accounts. */
  tenantId: number | null;
}

interface AuthState {
  accessToken: string | null;
  user: AuthUser | null;
  login: (data: {
    accessToken: string;
    userId: string;
    username: string;
    fullName: string;
    role: Role;
    tenantId: number | null;
  }) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      login: (data) =>
        set({
          accessToken: data.accessToken,
          user: {
            userId: data.userId,
            username: data.username,
            fullName: data.fullName,
            role: data.role,
            tenantId: data.tenantId ?? null,
          },
        }),
      logout: () => set({ accessToken: null, user: null }),
    }),
    { name: "osf-auth" },
  ),
);
